import { Pipe, PipeTransform } from "@angular/core";
import { getApprovalNotRequiredProductRequestItemCount } from "../helpers/get-approval-not-required-product-request-item-count";
import { ProductRequest } from "../models/ProductRequest";

@Pipe({name: 'approvalNotRequiredProductRequestItemCount'})
export class ApprovalNotRequiredProductRequestItemCountPipe implements PipeTransform {
  transform(value: ProductRequest): number {
    return getApprovalNotRequiredProductRequestItemCount(value);
  }
}